import React, { useEffect } from 'react';
import { useParams, Link, useNavigate } from 'react-router-dom';
import { SingleVideoItem } from '../../types/singleVideoType';
import { useAppSelector, useAppDispatch } from '../../store/store';
import { updateModal, fetchModalCardData } from '../../store/apiPageReducer';
import Loader from '../../components/loader/Loader';
import './_detailCard.scss';

const DetailCard: React.FC = () => {
  const dispatch = useAppDispatch();
  const state = useAppSelector((state) => state.apiPage);
  const { id } = useParams<'id'>();
  const { modalState } = state;
  const { isModalLoaded, modalCard, hasModalError } = modalState;
  const navigate = useNavigate();

  let title = '';
  let headerTitle = '';
  let description = '';
  let viewCount = '';
  let likeCount = '';
  let videoId = '';

  useEffect(() => {
    const isSingleCard = true;
    const cardID = id as string;
    dispatch(fetchModalCardData({ cardID, isSingleCard }));
    return () => {
      dispatch(updateModal({ isModalLoaded: false, modalCard: [], hasModalError: false }));
    };
  }, [dispatch]);

  if (hasModalError) {
    navigate('/');
  }
  if (isModalLoaded && !hasModalError) {
    const card = modalCard as SingleVideoItem;
    title = card.snippet.title;
    headerTitle = card.snippet.title;
    description = card.snippet.description;
    viewCount = card.statistics.viewCount;
    likeCount = card.statistics.likeCount;
    videoId = card.id;
    if (headerTitle.length > 54) headerTitle = headerTitle.slice(0, 55) + '...';
  }

  return (
    <React.Fragment>
      {!isModalLoaded && <Loader />}
      {isModalLoaded && modalCard && (
        <div className="detailcard" data-id={videoId}>
          <header>
            <Link to="/">
              <div className="btn">Go to the home page</div>
            </Link>
            <h2 className="detailcard__title">{headerTitle}</h2>
          </header>
          <div className="detailcard__img">
            <iframe
              src={`https://www.youtube.com/embed/${videoId}?autoplay=1`}
              frameBorder="0"
              allowFullScreen
            ></iframe>
          </div>
          <div className="detailcard__info">
            <h3 className="detailcard__title">{title}</h3>
            <p className="detailcard__description">{description}</p>
            <ul className="detailcard__props">
              <li className="detailcard__props-item">
                views: <span className="info__value">{viewCount}</span>
              </li>
              <li className="detailcard__props-item">
                likes: <span className="info__value">{likeCount}</span>
              </li>
            </ul>
          </div>
        </div>
      )}
      {hasModalError && (
        <div className={`no-matches-message`}>Sorry, we have a problem with api</div>
      )}
    </React.Fragment>
  );
};

export default DetailCard;
